__turbopack_context__.v({
  "notification-preference-toggle__alert": "notification-preference-toggle-module-scss-module__W_WUrG__notification-preference-toggle__alert",
  "notification-preference-toggle__content": "notification-preference-toggle-module-scss-module__W_WUrG__notification-preference-toggle__content",
  "notification-preference-toggle__header": "notification-preference-toggle-module-scss-module__W_WUrG__notification-preference-toggle__header",
  "notification-preference-toggle__title": "notification-preference-toggle-module-scss-module__W_WUrG__notification-preference-toggle__title",
});
